<template>
  <div class="rl__card_template">
    <div v-if="!isMobile()" class="rl__card_template-title">{{ title }}</div>
    <div v-if="!isMobile()"> 
      <div class="rl__card_template-container">
      <card
        v-for="(card, index) in initialItems"
        :data="card"
        :data-value="getIndex(index + 1)"
        v-bind:class="[isSelected(index + 1) ? 'selected' : '']"
        :isSelected="isSelected(index + 1)"
        :isHidden="isHidden(index + 1)"
        :key="card.headline + index"
        :onClick="() => setActiveItem(index + 1)"
      /> 
    </div>
     <div
        class="ctx-button primary ctx-blue ctx-medium-btn rl__card_template-showmore" 
        @click="showNextItems(24)" 
        v-if="isShowMoreVisible">
        <div v-if="loading" class="ctx-layout-spinner" style="display: block; position: unset">
          <i class="ctx-spinner"><i></i><i class="ico-ctx-loading-full"><i class="ico-ctx-loading-1"></i></i></i>
        </div>
        <div v-if="!loading">{{$t('showMoreLabel')}}</div>
      </div>
    </div>
   

    <div v-else>
      <div class="rl__accordion_card-title">{{ title }}</div>
      <accordion
        v-for="(card, index) in initialItems"
        :key="card.type + index"
        :onClick="() => setMobileActiveItem(index + 1)"
        :isSelected="isSelected(index + 1)">
        <template v-slot:title>
          <div class="rl__card_type">{{ card.type.toUpperCase() }}</div>
        </template>
        <template v-slot:sub-title>
          <div class="rl__card_headline"><v-clamp autoresize :max-lines="2" class="rl__card_headline">{{ card.headline }}</v-clamp>
          </div>
        </template>
        <template v-slot:body>
          <div class="rl__card_tag">{{ card.tags.join(" | ") }}</div>
          <div class="rl__card_products">{{ card.products.join(" | ").replaceAll('_', ' ') }}</div>
          <div class="rl__card_industries">{{ card.industries.join(" | ").replaceAll('_', ' ') }}</div>
          <div class="rl__card_description">
            <v-clamp autoresize :max-lines="3"> {{ card.description }}</v-clamp>
          </div>
          <div class="ctx-text rl__card_action" v-if="isVideo(card.link[$i18n.locale])">
            <a><span class="rl__resource-link ctx-style-orphaned-link ctx-img-link ctx-modal-link"
                :data-options="getYoutubeId(card.link[$i18n.locale])">View {{ card.type }}</span></a>
          </div>
          <div class="ctx-text rl__card_action" v-else>
            <a :href="card.link[$i18n.locale]"><span class="rl__resource-link ctx-style-orphaned-link">View {{ card.type }}</span></a>
          </div>
        </template>
      </accordion>
      <div
        class="ctx-button primary ctx-blue ctx-medium-btn rl__accordion_card-showmore"
        @click="showNextItems(10)"
        v-if="isShowMoreVisible">
        <div v-if="loading" class="ctx-layout-spinner" style="display: block; position: unset">
          <i class="ctx-spinner"><i></i><i class="ico-ctx-loading-full"><i class="ico-ctx-loading-1"></i></i></i>
        </div>
        <div v-if="!loading">{{$t('showMoreLabel')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "./Card";
import Accordion from "./Accordion";
import VClamp from "vue-clamp";
import commonMixins from "../mixins/common";

export default {
  name: "CardTemplate",
  mixins: [commonMixins],
  components: {
    Card,
    Accordion,
    VClamp,
  },
  props: {
    items: Array,
    title: String,
    rowCount: {
      type: String,
      default: "4",
    }
  },
  data() {
    return {
      currentItem: -1,
      initialItems: [],
      remainingItems: [],
      loading: false,
    };
  },

  methods: {
    showNextItems(count) {
      this.loading = true;
      setTimeout(() => {
        const nextItems = this.remainingItems.slice(0, count);
        if (this.remainingItems.length > count)
          this.remainingItems = this.remainingItems.slice(count);
        else this.remainingItems = [];
        this.initialItems = [...this.initialItems, ...nextItems];
        this.loading = false;
      }, 500);
    },
    setActiveItem(index) {
      this.currentItem = index;
    },

    setMobileActiveItem(index) {
      if (this.currentItem == index) this.currentItem = -1;
      else this.currentItem = index;
    },
    close(e) {
      if (!this.$el.contains(e.target) && !this.isMobile()) {
        this.currentItem = -1;
      }
    },
    isVideo(link) {
      return link.indexOf("youtube") > 1;
    },
    isSelected(index) {
      return this.currentItem === index;
    },
    getYoutubeId(link) {
      if (link.indexOf("youtube") > -1) {
        const queryParams = new RegExp("[?&]" + "v" + "=([^&#]*)").exec(link);
        if (queryParams) {
          return `videoId:${decodeURI(queryParams[1]) || 0};type:youtube`;
        } else {
          return null;
        }
      }
    },
    isHidden(index) {
      if (this.currentItem % 3 === 0) {
        if (this.currentItem === index + 1) return true;
      } else if (this.currentItem === index - 1) return true;
      else return false;
    },
    getIndex(index) {
      if ((index - 1) % 3 === 0) return 1;
      else if (index % 3 === 0) return 3;
      else return 2;
    },
  },
  watch: {
    items: function (val) {
      this.initialItems = val.slice(0, this.rowCount * 3);
      if (val.length > this.rowCount * 3)
        this.remainingItems = val.slice(this.rowCount * 3);
      else this.remainingItems = [];
    },
  },
  computed: {
    isShowMoreVisible() {
      return this.remainingItems.length > 0;
    },
  },
  mounted() {
    document.addEventListener("click", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  },
};
</script>


<style scoped lang="scss">
@import "../css/_global.scss";
@import "../css/components/mobile.scss";

.rl__card_template {
.rl__card_template-container {
  display: flex;
  flex-wrap: wrap;
  margin: auto;
}
 &-title {
    font-size: 24px;
    @include font-PublicSans-Medium();
  }

  &-showmore {
    cursor: pointer;
    margin-top: 1rem;
  }

  .rl__card {
    margin: 10px;
  }
  .ctx-layout-spinner .ctx-spinner {
  top: 15%;
  font-size: 1.2rem;

  .ico-ctx-loading-full {
    color: #fff;
    position:relative;
    font-size: 1.2rem !important;

    .ico-ctx-loading-1 {
      transform-origin:50% 52% 0;
    }
  }
}
}

.rl__card_industries , .rl__card_products {
  display: none;
}

</style>
